import { render, staticRenderFns } from "./examTypeSetting.vue?vue&type=template&id=fc01023a&scoped=true&"
import script from "./examTypeSetting.vue?vue&type=script&lang=js&"
export * from "./examTypeSetting.vue?vue&type=script&lang=js&"
import style0 from "./examTypeSetting.vue?vue&type=style&index=0&id=fc01023a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc01023a",
  null
  
)

export default component.exports